import React, {Component} from 'react';
import Api from "../../utils/Api";
import TimeRange from "../../utils/TimeRange";
import StaticFunctions from "../../utils/StaticFunctions";
import CSVDownloadButton from "../../utils/CSVDownloadButton";
import TimerangeSelector from "../../globalComponents/TimerangeSelector";
import LocationSelector from "../../globalComponents/LocationSelector";
import MachineSelector from "../../globalComponents/MachineSelector";
import ShiftSelector from "../../globalComponents/ShiftSelector";
import OperatorSelector from "../../globalComponents/OperatorSelector";
import MachineStates from "../../utils/MachineStates";
import LoadingSplash from "../../globalComponents/LoadingSplash";
import moment from "moment/moment";
import CheckBoxField from "../../utils/CheckBoxField";

class ReportOperatorOverview extends Component {
/*
    static propTypes = {
        baseData: PropTypes.object.isRequired,
        machines: PropTypes.instanceOf(Machines).isRequired,
    };
*/
    constructor(props) {

        super(props);

        this.api = new Api();

        this.translate = this.props.baseData.translate;
        this.userLanguage = this.props.baseData.userData.language;
        this.timeFormats = this.props.baseData.languages.getFormatByLanguage(this.userLanguage);
        this.saveSettings = this.props.baseData.saveSettings;

        this.state = {
            reportStatus: null,
            reportParams: null,
            timeRange: null, // TimeRange
            showSubThreadbreaks: false,
            selectedLocationId: 0,
            selectedLocationName: 'all',
            selectedMachine: {value: 'all', label: this.translate('all')},
            selectedOperator: {value: 'all', label: this.translate('all')},
            selectedShift: null,
            currentCompanyId: props.baseData.companies.currentCompany ? props.baseData.companies.currentCompany.id : null,
            requestedParams: null, // stringified parameters to prevent double-request
            tableData: null,
            errorData: null
        };

        this.reportKey = 'operatorOverview';

        this.requestReport = this.requestReport.bind(this);
        this.timerangeChanged = this.timerangeChanged.bind(this);
        this.locationSelected = this.locationSelected.bind(this);
        this.machineSelected = this.machineSelected.bind(this);
        this.shiftSelected = this.shiftSelected.bind(this);
        this.toggleCheckBox = this.toggleCheckBox.bind(this);

    }

    componentWillMount() {

        const newState = {};

        // Timerange aus den userprops laden
        const tr = new TimeRange();
        const momentYesterday = moment().add(-1, 'days');

        tr.setRange(momentYesterday.clone().startOf('day'), momentYesterday.clone().endOf('day'));

        if (tr && tr.isValid()) newState.timeRange = tr;

        // Standort aus den userprops laden
        const locationId = this.getReportSetting('locationId');

        if (locationId) newState.selectedLocationId = locationId;

        // Machines aus den userprops laden
        const machine = this.getReportSetting('machine');

        if (machine) newState.selectedMachine = JSON.parse(machine);

        // Operator-ID aus den userprops laden
        const operator = this.getReportSetting('operator');

        if (operator) newState.selectedOperator = JSON.parse(operator);

        // Shift aus den userprops laden
        const sid = this.getReportSetting('shiftId');

        if (sid) {
            let shift = this.props.baseData.shifts.getShiftById(sid);

            if (shift) newState.selectedShift = shift;
        }

        // ShowSubThreadbreaks aus den userprops laden
        const showSubThreadbreaks = this.getReportSetting('showSubThreadbreaks', false);

        if (showSubThreadbreaks) newState.showSubThreadbreaks = true;

        if (newState) {
            this.setState(newState);
        }

    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.baseData.companies && nextProps.baseData.companies.currentCompany) {
            if (nextProps.baseData.companies.currentCompany.id !== this.state.currentCompanyId) {
                this.setState({
                    selectedLocationId: 0,
                    selectedMachine: {value: 'all', label: this.translate('all')},
                    selectedOperator: {value: 'all', label: this.translate('all')},
                    selectedShift: null,
                    tableData: null,
                    currentCompanyId: nextProps.baseData.companies.currentCompany.id
                });
            }
        }

    }

    getReportSetting(key, defaultValue = null) {

        const settings = this.props.baseData.userData.settings ? this.props.baseData.userData.settings : {};
        const reportSettings = (settings.hasOwnProperty('reports') && settings.reports.hasOwnProperty(this.reportKey)) ? settings.reports[this.reportKey] : {};

        return (reportSettings.hasOwnProperty(key)) ? reportSettings[key] : defaultValue;

    }

    getRequestParams() {

        const tr = this.state.timeRange;
        const dateFrom = tr ? tr.getFromMoment() : null;
        const dateTill = tr ? tr.getTillMoment() : null;
        const locationId = this.state.selectedLocationId;
        const machineId = this.state.selectedMachine ? this.state.selectedMachine.value : null;
        const machineIds = (machineId === 'all') ? this.props.machines.getAllMachineIdsFromLocation(locationId) : [machineId];
        const operatorId = (this.state.selectedOperator) ? this.state.selectedOperator.value : null;

        // Check, if all data is set
        if (!dateFrom || !dateTill || locationId === null || !machineId || !operatorId) return null;
        if (!dateFrom.isValid() || !dateTill.isValid()) return null;

        return {
            companyId: this.props.baseData.companies.currentCompany.id,
            locationId: locationId,
            machineIds: machineIds,
            operatorId: operatorId,
            from: dateFrom.unix(),
            till: dateTill.unix(),
            showSubThreadbreaks: this.state.showSubThreadbreaks,
            shift: this.state.selectedShift ? this.state.selectedShift.getRange() : null,
            timezone: this.props.baseData.companies.currentCompany.timezone,
        };

    }

    requestReport() {

        if (this.state.reportStatus === 'requested') return null;

        const params = this.getRequestParams();

        if (params === null) return null;

        const sParams = JSON.stringify(params);

        if (sParams === this.state.requestedParams) return null;

        const {reportParams, ...newReportParams} = {...this.state};

        const callback = function(res) {
            if (res) {
                this.setState({
                    reportStatus: 'ready',
                    tableData: res,
                    errorData: null,
                });
            }
        }.bind(this);

        const error = function(error) {
            if (error) {
                this.setState({
                    reportStatus: 'error',
                    tableData: null,
                    errorData: error,
                });
            }
        }.bind(this);

        this.setState({
            reportStatus: 'requested',
            reportParams: newReportParams,
            requestedParams: sParams,
            tableData: null,
            errorData: null,
        }, () => {
            this.api.request('ReportOperatorOverview', params, callback, error);
        });

    }

    timerangeChanged(newRange) {

        if (newRange && (newRange instanceof TimeRange) && newRange.isValid()) {
            this.setState({
                timeRange: newRange,
            });

            // Safe Timerange to Userconfig
            if (this.saveSettings) {
                this.saveSettings('reports', {report: this.reportKey, key: 'timeRange', value: newRange.serialize()});
            }
        }

    }

    locationSelected(location) {

        const allMachines = {value: 'all', label: this.translate('all')};

        this.setState({
            selectedLocationId: location ? parseInt(location.id) : 0,
            selectedLocationName: location ? location.name : '',
            selectedMachine: allMachines
        });

        if (this.saveSettings && location) {
            this.saveSettings('reports', {report: this.reportKey, key: 'locationId', value: location.id});
            this.machineSelected(allMachines);
        }

    }

    machineSelected(machine) {

        this.setState({
            selectedMachine: machine
        });

        // Safe Machine to Userconfig
        if (this.saveSettings) {
            this.saveSettings('reports', {report: this.reportKey, key: 'machine', value: ((machine) ? JSON.stringify(machine) : null)});
        }

    }

    operatorSelected(operator) {

        this.setState({
            selectedOperator: operator
        });

        // Safe Operator-ID to Userconfig
        if (this.saveSettings) {
            this.saveSettings('reports', {report: this.reportKey, key: 'operator', value: ((operator) ? JSON.stringify(operator) : null)});
        }

    }

    shiftSelected(shift) {

        this.setState({
            selectedShift: shift
        });

        // Safe Shift-id to Userconfig
        if (this.saveSettings && shift) {
            this.saveSettings('reports', {report: this.reportKey, key: 'shiftId', value: shift.id});
        }

    }

    toggleCheckBox(fieldName, isChecked) {

        const state = {...this.state};

        state[fieldName] = isChecked;

        this.setState(state);

        // Safe option to Userconfig
        if (this.saveSettings && isChecked !== null) {
            this.saveSettings('reports', {report: this.reportKey, key: fieldName, value: isChecked});
        }

    }

    getErrorBlock() {

        let errorBlock = null;

        if (this.state.errorData || this.state.reportStatus === 'error') {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('errorOccured')}</span>;
        } else if (!this.state.reportParams.timeRange || !this.state.reportParams.timeRange.isValid()) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('timerangeIsUnset')}</span>;
        } else if (!this.state.reportParams.timeRange || !this.state.reportParams.timeRange.isNotInFuture()) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('timerangeIsInFuture')}</span>;
        } else if (!this.state.reportParams && this.state.reportParams.selectedLocationId === null) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('locationIsUnset')}</span>;
        } else if (!this.state.reportParams && this.state.reportParams.selectedMachine === null) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('machineIsUnset')}</span>;
        } else if (!this.state.reportParams && this.state.reportParams.selectedDesign === null) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('designIsUnset')}</span>;
        } else if (this.state.tableData === null) {
            errorBlock = <LoadingSplash color={'dark'}/>;
        } else if (this.state.tableData && this.state.tableData.length === 0) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('noDataFound')}</span>;
        }

        return (errorBlock !== null) ? errorBlock : null;

    }

    getChartHeadline(timeRange, otherParams = {}) {

        const params = {
            location: {id: this.state.reportParams.selectedLocationId, name: this.state.reportParams.selectedLocationName},
            locationTitle: this.translate('location'),
            allLocationsTitle: this.translate('allLocations'),
            machine: this.state.reportParams.selectedMachine,
            machineTitle: this.translate('machine'),
            allMachinesTitle: this.translate('allMachines'),
            operator: this.state.reportParams.selectedOperator,
            operatorTitle: this.translate('operator'),
            allOperatorTitle: this.translate('allOperator'),
            design: this.state.reportParams.selectedDesign,
            designTitle: this.translate('design'),
            allDesignsTitle: this.translate('allDesigns'),
            timerange: timeRange,
            formatedDate: this.timeFormats.fullDate,
            timerangeTitle: this.translate('timerange'),
            shift: this.state.reportParams.selectedShift,
            shiftTitle: this.translate('shift'),
            groupingOpt: this.groupingOpt,
            groupingId: this.state.reportParams.selectedGrouping,
            groupingTitle: this.translate('grouping')
        };

        return StaticFunctions.createReportHeadlineFromParams({...params, ...otherParams});

    }

    getTableHeader() {

        const headline = this.getChartHeadline(this.state.timeRange);

        return (
            <nav>
                <h1>{headline}</h1>
            </nav>
        );

    }

    getCsvContent() {

        const csvContent = {
            csvTitle: [],
            csvColumns: [],
            csvData: [],
        };

        if (this.state.reportStatus === 'ready') {
            csvContent.csvTitle.push(this.getChartHeadline(this.state.reportParams.timeRange));
            csvContent.csvColumns.push(this.getCsvTableColumns());
            csvContent.csvData.push(this.getCsvTableRows());
        }

        return csvContent;

    }

    getCsvTableColumns() {

        return [
            {
                key:  'label1',
                name: ' ',
            },
            {
                key:  'value1',
                name: ' ',
            },
            {
                key: 'emptyColumn',
                name: ' ',
            },
            {
                key:  'label2',
                name: ' ',
            },
            {
                key:  'value2',
                name: ' ',
            },
        ];

    }

    getCsvTableRows() {

        const data = this.calculateReportData();
        const csvData = [];

        if (data) {
            csvData.push({
                emptyColumn: ' ',
                label1: this.translate('totalStitches'),
                value1: StaticFunctions.formatedNumber(data.stitches),
                label2: this.translate('stitchTime'),
                value2: StaticFunctions.convertSecondsToFormatedString(data.stitchTime),
            });

            csvData.push({
                emptyColumn: ' ',
                label1: this.translate('totalThreadbreaks'),
                value1: StaticFunctions.formatedNumber(data.threadbreaks),
                label2: this.translate('threadbreakTime'),
                value2: StaticFunctions.convertSecondsToFormatedString(data.threadbreakTime),
            });

            csvData.push({
                emptyColumn: ' ',
                label1: this.translate('passings'),
                value1: StaticFunctions.formatedNumber(data.passings),
                label2: this.translate('setupTime'),
                value2: StaticFunctions.convertSecondsToFormatedString(data.setupTime),
            });

            csvData.push({
                emptyColumn: ' ',
                label1: this.translate('numberOfPieces'),
                value1: StaticFunctions.formatedNumber(data.pieces),
                label2: this.translate('productionTime'),
                value2: StaticFunctions.convertSecondsToFormatedString(data.productionTime),
            });

            csvData.push({
                emptyColumn: ' ',
                label1: this.translate('stitchesPerMin'),
                value1: StaticFunctions.formatedNumber(data.stitchesPerMin, 2),
                label2: this.translate('operatorBreaks'),
                value2: StaticFunctions.convertSecondsToFormatedString(data.operatorBreaks),
            });

            csvData.push({
                emptyColumn: ' ',
                label1: ' ',
                value1: ' ',
                label2: this.translate('downTime'),
                value2: StaticFunctions.convertSecondsToFormatedString(data.downTime),
            });

            csvData.push({
                emptyColumn: ' ',
                label1: ' ',
                value1: ' ',
                label2: this.translate('totalTime'),
                value2: StaticFunctions.convertSecondsToFormatedString(data.totalTime),
            });
        }

        return csvData;

    }

    getTableColumns() {

        return [
            {
                key: 'img',
                nameKey: 'design',
            },
            {
                key: 'designId',
                nameKey: 'designId',
                sortType: 'string',
            },
            {
                key: 'totalStitches',
                nameKey: 'totalStitches',
                classes: 'text-right',
                sortType: 'int',
            },
            {
                key: 'pieces',
                nameKey: 'numberOfPieces',
                classes: 'text-right',
                sortType: 'int',
            },
        ];

    }

    calculateReportData() {

        const tableData = this.state.tableData;
        const calculatedData = {
            stitches: 0,
            threadbreaks: 0,
            passings: 0,
            pieces: 0,
            utilization: 0,
            totalTime: 0,
            setupTime: 0,
            productionTime: 0,
            stitchTime: 0,
            threadbreakTime: 0,
            downTime: 0,
            operatorBreaks: 0,
            stitchesPerMin: 0,
            entirePastTime: 0,
            status: {},
        };

        if (tableData === null || this.state.reportParams.selectedLocationId === null || !this.state.reportParams.selectedMachine || !this.state.reportParams.selectedOperator) return calculatedData;

        if (tableData) {
            calculatedData.stitches = parseInt(tableData.stitches);
            calculatedData.threadbreaks = parseInt(tableData.threadbreaks);
            calculatedData.passings = parseInt(tableData.passings);
            calculatedData.pieces = parseInt(tableData.pieces);

            calculatedData.stitchTime = MachineStates.calculateStitchTime(tableData.status, 's');
            calculatedData.threadbreakTime = MachineStates.calculateThreadbreakTime(tableData.status, 's');
            calculatedData.setupTime = MachineStates.calculateSetupTime(tableData.status, 's');
            calculatedData.productionTime = MachineStates.calculateProductionTime(tableData.status, 's');
            calculatedData.operatorBreaks = MachineStates.calculateBreakTime(tableData.status, 's');
            calculatedData.downTime = MachineStates.calculateDownTime(tableData.status, 's');
            calculatedData.totalTime = MachineStates.calculateTotalTime(tableData.status, 's');

            calculatedData.entirePastTime = StaticFunctions.getSumOfArray(StaticFunctions.arrayMapObjectToProperty(tableData.status, 'pastTime'));

            if (calculatedData.totalTime > 0 && calculatedData.productionTime > 0) calculatedData.utilization = (100 / calculatedData.totalTime) * calculatedData.productionTime;
            if (calculatedData.stitches > 0 && calculatedData.totalTime > 0) calculatedData.stitchesPerMin = (calculatedData.stitches / (calculatedData.totalTime / 60));
        }

        return calculatedData;

    }

    calculateReportDataSave() {

        const tableData = this.state.tableData;
        const calculatedData = {
            stitches: 0,
            threadbreaks: 0,
            passings: 0,
            pieces: 0,
            utilization: 0,
            totalTime: 0,
            productionTime: 0,
            setupTime: 0,
            stitchTime: 0,
            threadbreakTime: 0,
            downTime: 0,
            operatorBreaks: 0,
            stitchesPerMin: 0,
            entirePastTime: 0,
            status: {},
        };

        if (tableData === null || this.state.reportParams.selectedLocationId === null || !this.state.reportParams.selectedMachine || !this.state.reportParams.selectedOperator) return calculatedData;

        if (tableData) {
            for (let machineKey in tableData) {
                let machineData = tableData[machineKey];
                let machineHeads = this.props.machines.getMachineHeadsByMachineId(machineData.machineId);
                let objPassings = StaticFunctions.findObjectInArray(machineData.status, 'status', 1012);
                let objThreadbreakTime = StaticFunctions.findObjectInArray(machineData.status, 'status', 1066);
                let objOperatorBreaks = StaticFunctions.findObjectInArray(machineData.status, 'status', 1016);
                let objStitchTime = StaticFunctions.findObjectInArray(machineData.status, 'status', 1015);

                calculatedData.setupTime += MachineStates.calculateSetupTime(machineData.status, 's');
                calculatedData.productionTime += MachineStates.calculateProductionTime(machineData.status, 's');
                calculatedData.downTime += MachineStates.calculateDownTime(machineData.status, 's');
                calculatedData.totalTime += MachineStates.calculateTotalTime(machineData.status, 's');

                calculatedData.entirePastTime += StaticFunctions.getSumOfArray(StaticFunctions.arrayMapObjectToProperty(machineData.status, 'pastTime'));
                calculatedData.stitches += parseInt(machineData.stitches);
                calculatedData.threadbreaks += parseInt(machineData.threadbreaks);

                if (objPassings) calculatedData.passings += parseInt(objPassings.counter);
                if (objPassings) calculatedData.pieces += parseInt(objPassings.counter) * machineHeads;
                if (objThreadbreakTime) calculatedData.threadbreakTime += parseInt(objThreadbreakTime.counter);
                if (objOperatorBreaks) calculatedData.operatorBreaks += parseInt(objOperatorBreaks.counter);
                if (objStitchTime) calculatedData.stitchTime += parseInt(objStitchTime.counter);
            }

            if (calculatedData.totalTime > 0 && calculatedData.productionTime > 0) calculatedData.utilization = (100 / calculatedData.totalTime) * calculatedData.productionTime;
            if (calculatedData.stitches > 0 && calculatedData.totalTime > 0) calculatedData.stitchesPerMin = (calculatedData.stitches / (calculatedData.totalTime / 60));
        }

        return calculatedData;

    }

    renderStatusBlock(statusData) {

        if (!statusData) return null;

        let statusBlock = [];

        for (let statusCode in statusData) {
            let status = statusData[statusCode];
            let formatedPastTime = StaticFunctions.convertSecondsToFormatedString(status.pastTime / 1000);

            statusBlock.push(
                <tr key={statusCode}>
                    <td className="text-left labelSpan">{this.translate(statusCode)}</td>

                    <td className="text-left">
                        <input
                            name={statusCode}
                            type="text"
                            value={formatedPastTime}
                            disabled={true}
                        />
                    </td>
                </tr>
            );
        }

        return (
            <div className="formRow clearfix">
                <div className="col-sm-4">
                    <div className="ma-bo-10">
                        <table>
                            <tbody>
                                {statusBlock}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );

    }

    renderRequestButton() {

        const reportParams = this.getRequestParams();
        const sParams = JSON.stringify(reportParams);

        if (this.state.reportStatus === 'requested' || sParams === this.state.requestedParams) {
            return (
                <a className="prewLink disabled-link">{this.translate('requestReport')}</a>
            );
        } else {
            return (
                <a className="prewLink orangeButton" onClick={() => this.requestReport()}>{this.translate('requestReport')}</a>
            );
        }

    }

    renderDownloadButtons() {

        if (this.state.reportStatus !== 'ready' || !this.state.reportParams || this.getErrorBlock() !== null) {
            return (
                <div className="bottomLinks clearfix">
                    <div><button className="disabled-link">{this.translate('csvDownloadLabel') + ' (CSV)'}</button></div>
                </div>
            );
        } else {
            const csvContent = this.getCsvContent();

            return (
                <div className="bottomLinks clearfix">
                    <CSVDownloadButton
                        baseData={this.props.baseData}
                        fileName={this.props.reportName}
                        csvTitle={csvContent.csvTitle}
                        columns={csvContent.csvColumns}
                        data={csvContent.csvData}
                    />
                </div>
            );
        }

    }

    renderReportArea() {

        if (this.state.reportStatus === null) return null;
        if (this.state.reportStatus === 'requested') return <LoadingSplash color={'dark'}/>;

        const errorBlock = this.getErrorBlock();

        if (errorBlock !== null) return errorBlock;

        const headline = this.getChartHeadline(this.state.reportParams.timeRange);
        const reportData = this.calculateReportData();

        return (
            <div>
                <nav>
                    <h1>{headline}</h1>
                </nav>

                <div className="formSettings">
                    <div className="formRow clearfix">
                        <div className="col-sm-4">
                            <div className="ma-bo-10">
                                <table>
                                    <tbody>
                                        <tr>
                                            <td className="text-left labelSpan">{this.translate('totalStitches')}</td>

                                            <td className="text-left">
                                                <input
                                                    name="totalStitches"
                                                    type="text"
                                                    value={StaticFunctions.formatedNumber(reportData.stitches)}
                                                    disabled={true}
                                                />
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="text-left labelSpan">{this.translate('totalThreadbreaks')}</td>

                                            <td className="text-left">
                                                <input
                                                    name="totalThreadbreaks"
                                                    type="text"
                                                    value={StaticFunctions.formatedNumber(reportData.threadbreaks)}
                                                    disabled={true}
                                                />
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="text-left labelSpan">{this.translate('passings')}</td>

                                            <td className="text-left">
                                                <input
                                                    name="passings"
                                                    type="text"
                                                    value={StaticFunctions.formatedNumber(reportData.passings)}
                                                    disabled={true}
                                                />
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="text-left labelSpan">{this.translate('numberOfPieces')}</td>

                                            <td className="text-left">
                                                <input
                                                    name="numberOfPieces"
                                                    type="text"
                                                    value={StaticFunctions.formatedNumber(reportData.pieces)}
                                                    disabled={true}
                                                />
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="text-left labelSpan">{this.translate('stitchesPerMin')}</td>

                                            <td className="text-left">
                                                <input
                                                    name="stitchesPerMin"
                                                    type="text"
                                                    value={StaticFunctions.formatedNumber(reportData.stitchesPerMin, 2)}
                                                    disabled={true}
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="col-sm-4">
                            <div className="ma-bo-10">
                                <table>
                                    <tbody>
                                        <tr>
                                            <td className="text-left labelSpan">{this.translate('stitchTime')}</td>

                                            <td className="text-left">
                                                <input
                                                    name="stitchTime"
                                                    type="text"
                                                    value={StaticFunctions.convertSecondsToFormatedString(reportData.stitchTime)}
                                                    disabled={true}
                                                />
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="text-left labelSpan">{this.translate('threadbreakTime')}</td>

                                            <td className="text-left">
                                                <input
                                                    name="threadbreakTime"
                                                    type="text"
                                                    value={StaticFunctions.convertSecondsToFormatedString(reportData.threadbreakTime)}
                                                    disabled={true}
                                                />
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="text-left labelSpan">{this.translate('setupTime')}</td>

                                            <td className="text-left">
                                                <input
                                                    name="setupTime"
                                                    type="text"
                                                    value={StaticFunctions.convertSecondsToFormatedString(reportData.setupTime)}
                                                    disabled={true}
                                                />
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="text-left labelSpan">{this.translate('productionTime')}</td>

                                            <td className="text-left">
                                                <input
                                                    name="productionTime"
                                                    type="text"
                                                    value={StaticFunctions.convertSecondsToFormatedString(reportData.productionTime)}
                                                    disabled={true}
                                                />
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="text-left labelSpan">{this.translate('operatorBreaks')}</td>

                                            <td className="text-left">
                                                <input
                                                    name="operatorBreaks"
                                                    type="text"
                                                    value={StaticFunctions.convertSecondsToFormatedString(reportData.operatorBreaks)}
                                                    disabled={true}
                                                />
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="text-left labelSpan">{this.translate('downTime')}</td>

                                            <td className="text-left">
                                                <input
                                                    name="downTime"
                                                    type="text"
                                                    value={StaticFunctions.convertSecondsToFormatedString(reportData.downTime)}
                                                    disabled={true}
                                                />
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="text-left labelSpan">{this.translate('totalTime')}</td>

                                            <td className="text-left">
                                                <input
                                                    name="totalTime"
                                                    type="text"
                                                    value={StaticFunctions.convertSecondsToFormatedString(reportData.totalTime)}
                                                    disabled={true}
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    {/*statusData*/}
                </div>
            </div>
        );

    }

    render() {

        const timerangeFormat = this.timeFormats.fullDate;
        const machineOptions = this.props.machines;

        const reportArea = this.renderReportArea();
        const requestButton = this.renderRequestButton();
        const downloadArea = this.renderDownloadButtons();

        return (
            <div>
                <div id="reportSettings" className="clearfix">
                    <div className="clearfix">
                        <div className="col-sm-4">
                            <div className="ma-bo-10">
                                <h4>{this.translate('timerange')}</h4>

                                <div>
                                    <TimerangeSelector
                                        TimeRange={this.state.timeRange}
                                        displayFormat={timerangeFormat}
                                        translate={this.translate}
                                        onTimeRangeChanged={this.timerangeChanged}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-2">
                            <div className="ma-bo-10">
                                <h4>{this.translate('location')}</h4>

                                <div>
                                    <LocationSelector
                                        baseData={this.props.baseData}
                                        currentLocation={this.state.selectedLocationId}
                                        placeholder={this.translate('select') + '...'}
                                        onLocationSelected={(location) => this.locationSelected(location)}
                                    />
                                </div>
                            </div>

                            <div className="ma-bo-10">
                                <h4>{this.translate('machine')}</h4>

                                <div>
                                    <MachineSelector
                                        machine={machineOptions}
                                        currentMachine={this.state.selectedMachine}
                                        currentLocation={this.state.selectedLocationId}
                                        translate={this.translate}
                                        addAllOption={true}
                                        onMachineSelected={(machine) => this.machineSelected(machine)}
                                    />
                                </div>
                            </div>

                            <div className="ma-bo-10">
                                <h4>{this.translate('operator')}</h4>

                                <div>
                                    <OperatorSelector
                                        baseData={this.props.baseData}
                                        currentOperator={this.state.selectedOperator}
                                        addAllOption={true}
                                        onOperatorSelected={(operator) => this.operatorSelected(operator)}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-2">
                            <div className="ma-bo-10">
                                <h4>{this.translate('shift')}</h4>

                                <div>
                                    <ShiftSelector
                                        baseData={this.props.baseData}
                                        currentShift={this.state.selectedShift}
                                        onShiftSelected={(shift) => this.shiftSelected(shift)}
                                    />
                                </div>
                            </div>

                            <div className="formSettings ma-bo-10">
                                <h4>{this.translate('options')}</h4>

                                <div className="formBox">
                                    <CheckBoxField
                                        name="showSubThreadbreaks"
                                        label={this.translate('showSubThreadbreaks')}
                                        isChecked={this.state.showSubThreadbreaks}
                                        onChange={this.toggleCheckBox}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-2">
                            <div className="ma-bo-10">
                                <h4>{this.translate('downloadReport')}</h4>

                                {downloadArea}
                            </div>
                        </div>
                    </div>

                    <div className="bottomLinks clearfix">
                        {requestButton}
                    </div>
                </div>

                <div id="reportArea" className="clearfix">
                    {reportArea}
                </div>
            </div>
        );

    }

}

export default ReportOperatorOverview;
